import Vue from 'vue'
import Router from 'vue-router'

// home page
import home from '@/components/home/home'

// auth pages
import lostLogin from '@/components/lost-login/lost-login'
import resetPwd from '@/components/lost-login/reset-password'
import createAccount from '@/components/create-account/create-account'
import confirmEmail from '@/components/create-account/confirm-email'

// news pages
import newsDetail from '@/components/news/news-detail'
import newsEdit from '@/components/news/news-edit'
import newsList from '@/components/news/news-list'
import newsCreate from '@/components/news/news-create'

// team pages
import teamList from '@/components/team/team-list'
import teamDetail from '@/components/team/team-detail'
import teamCreate from '@/components/team/team-create'
import teamEdit from '@/components/team/team-edit'
import teamCustomize from '@/components/team/team-customize'
import teamBaseSkills from '@/components/team/team-base-skills'

// team purchases
import teamPurchases from '@/components/team/team-purchases'
import teamRevoke from '@/components/team/team-revoke'
import playerPurchase from '@/components/team/purchases/player-purchase'
import stuffPurchase from '@/components/team/purchases/stuff-purchase'

// match report
import mrStep1 from '@/components/match-reports/mr-step-1'
import mrStep2 from '../components/match-reports/2020/mr-step-2.vue'
import mrStep3 from '@/components/match-reports/mr-step-3'
import mrStep5 from '@/components/match-reports/mr-step-5'
import mrStep6 from '@/components/match-reports/mr-step-6'
import mrDetail from '@/components/match-reports/mr-detail'
import mrList from '@/components/match-reports/mr-list'

// dungeon bowl report
import mrDBStep2 from '@/components/match-reports/mr-db-step-2'
import mrDBStep4 from '@/components/match-reports/mr-db-step-4'
import mrDBStep5 from '@/components/match-reports/mr-db-step-5'
import mrDBDetail from '@/components/match-reports/mr-db-detail'

// ranking
import ranking from '@/components/ranking/ranking'

// my account
import MyAccount from '@/components/my-account/my-account'
import MyInfos from '@/components/my-account/my-infos'
import MyTeams from '@/components/my-account/my-teams'
import MyMatchs from '@/components/my-account/my-matchs'

// ruleset
import pageCreate from '@/components/page/page-create'
import pageDetail from '@/components/page/page-detail'
import pageList from '@/components/page/page-list'
import pageEdit from '@/components/page/page-edit'

// bingo EDF
import bingoEDF from '@/components/game/bingo-edf'

import guards from '@/router/guards'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: home
    },
    {
      path: '/home',
      name: 'Home',
      component: home
    },
    {
      name: 'LostLogin',
      path: '/lostlogin',
      component: lostLogin
    },
    {
      name: 'ResetPwd',
      path: '/resetpwd/:uid/:token',
      component: resetPwd,
      props: true
    },
    {
      name: 'createAccount',
      path: '/createaccount',
      component: createAccount
    },
    {
      name: 'confirmEmail',
      path: '/confirm_email/:token',
      component: confirmEmail,
      props: true
    },
    {
      name: 'NewsDetail',
      path: '/news/:id/',
      component: newsDetail,
      props: true
    },
    {
      name: 'NewsEdit',
      path: '/news/:id/edit',
      component: newsEdit,
      props: true
    },
    {
      name: 'NewsCreate',
      path: '/newscreate',
      component: newsCreate
    },
    {
      name: 'NewsList',
      path: '/news',
      component: newsList
    },
    {
      name: 'TeamList',
      path: '/teams',
      component: teamList
    },
    {
      name: 'TeamDetail',
      beforeEnter: guards.canSeeTeam,
      path: '/teams/:id',
      component: teamDetail,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'TeamCustomize',
      beforeEnter: guards.requireAdmin,
      path: '/teams/:id/customize',
      component: teamCustomize,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'TeamEdit',
      path: '/teams/:id/edit',
      component: teamEdit,
      props: true
    },
    {
      name: 'TeamCreate',
      path: '/team/create',
      component: teamCreate
    },
    {
      name: 'TeamPurchases',
      path: '/team/:id/purchases',
      component: teamPurchases,
      props: true,
      children: [
        {
          name: 'players-purchase',
          path: 'players',
          component: playerPurchase
        },
        {
          name: 'stuff-purchase',
          path: 'stuff',
          component: stuffPurchase
        },
        {
          name: 'starplayer-purchase',
          path: 'starplayer',
          component: MyMatchs
        },
        {
          name: 'stadium-purchase',
          path: 'stadium',
          component: MyMatchs
        }
      ]
    },
    {
      name: 'TeamRevoke',
      path: '/team/:id/revoke',
      component: teamRevoke,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'TeamBaseSkills',
      path: '/team/:id/baseskills',
      component: teamBaseSkills,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrStep1',
      path: '/matchreport/:id/step/1',
      component: mrStep1,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrStep2',
      path: '/matchreport/:id/step/2',
      component: mrStep2,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrStep3',
      path: '/matchreport/:matchId/action-step/:teamid/:id',
      component: mrStep3,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        props.teamid = +props.teamid
        props.matchId = +props.matchId
        return props
      }
    },
    {
      name: 'mrStep5',
      path: '/matchreport/:id/step/5',
      component: mrStep5,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrStep6',
      path: '/matchreport/:id/step/6/',
      component: mrStep6,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrDBStep2',
      path: '/matchreport/:id/db-step/2/',
      component: mrDBStep2,
      props: true
    },
    {
      name: 'mrDBStep4',
      path: '/matchreport/:id/db-step/4/',
      component: mrDBStep4,
      props (route) {
        const props = { ...route.params }
        props.id = +props.id
        return props
      }
    },
    {
      name: 'mrDBStep5',
      path: '/matchreport/:id/db-step/5/',
      component: mrDBStep5,
      props: true
    },
    {
      name: 'matchReportDetail',
      path: '/matchreport/:id',
      component: mrDetail,
      props: true
    },
    {
      name: 'DBDetail',
      path: '/db-report/:id',
      component: mrDBDetail,
      props: true
    },
    {
      name: 'matchReportList',
      path: '/matchreport/',
      component: mrList
    },
    {
      path: '/ranking/',
      name: 'rankingGeneral',
      component: ranking
    },
    {
      path: '/page/',
      name: 'pageList',
      component: pageList
    },
    {
      path: '/page/:id/detail/',
      name: 'pageDetail',
      props: true,
      component: pageDetail
    },
    {
      path: '/page/create',
      name: 'pageCreate',
      component: pageCreate
    },
    {
      path: '/page/:id/edit/',
      name: 'pageEdit',
      props: true,
      component: pageEdit
    },
    {
      path: '/bingo-edf',
      name: 'bingoedf',
      props: true,
      component: bingoEDF
    },
    {
      path: '/account',
      component: MyAccount,
      children: [
        {
          name: 'myInfos',
          path: 'myinfos',
          component: MyInfos
        },
        {
          name: 'myTeams',
          path: 'myteams',
          component: MyTeams
        },
        {
          name: 'myMatchs',
          path: '/',
          component: MyMatchs
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js